import { ApiClient } from './ApiClient.js';

function _authHeaders() {
    const token = ApiClient.getToken();
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
}

const BASE = `${ApiClient.getBaseUrl()}/api/v1/roles/permissions`;

export class RolePermissionService {

    static async getAllRolePermissions() {
        const res = await fetch(BASE, { headers: _authHeaders() });
        if (!res.ok) throw new Error('Failed to fetch role permissions');
        const json = await res.json();
        return json.data || {};
    }

    static async getRolePermissions(roleName) {
        const res = await fetch(`${BASE}/${encodeURIComponent(roleName)}`, { headers: _authHeaders() });
        if (!res.ok) throw new Error(`Failed to fetch permissions for role ${roleName}`);
        const json = await res.json();
        return json.data || null;
    }

    static async updateRolePermissions(roleName, permissions, scopes = null) {
        const body = { permissions };
        if (scopes && typeof scopes === 'object') {
            body.scopes = scopes;
        }
        const res = await fetch(`${BASE}/${encodeURIComponent(roleName)}`, {
            method: 'PUT',
            headers: _authHeaders(),
            body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error(`Failed to update permissions for role ${roleName}`);
        const json = await res.json();
        return json.data || null;
    }

    static async getUserEffectivePermissions(userId) {
        const res = await fetch(`${BASE}/user/${encodeURIComponent(userId)}`, { headers: _authHeaders() });
        if (!res.ok) throw new Error('Failed to fetch user permissions');
        const json = await res.json();
        return json.data || null;
    }

    static async setUserPermissionOverrides(userId, permissions) {
        const res = await fetch(`${BASE}/user/${encodeURIComponent(userId)}`, {
            method: 'PUT',
            headers: _authHeaders(),
            body: JSON.stringify({ permissions }),
        });
        if (!res.ok) throw new Error('Failed to set user permission overrides');
        const json = await res.json();
        return json.data || null;
    }

    static async clearUserPermissionOverrides(userId) {
        const res = await fetch(`${BASE}/user/${encodeURIComponent(userId)}`, {
            method: 'DELETE',
            headers: _authHeaders(),
        });
        if (!res.ok) throw new Error('Failed to clear user permission overrides');
        const json = await res.json();
        return json.data || null;
    }

    static async getOverrideSummary() {
        const res = await fetch(`${BASE}/override-summary`, { headers: _authHeaders() });
        if (!res.ok) throw new Error('Failed to fetch permission override summary');
        const json = await res.json();
        return json.data || { by_role: {}, users: [] };
    }

    static async seedDefaults() {
        const res = await fetch(`${ApiClient.getBaseUrl()}/api/v1/admin/seed-permissions`, {
            method: 'POST',
            headers: _authHeaders(),
        });
        if (!res.ok) throw new Error('Failed to seed default permissions');
        const json = await res.json();
        return json.data || null;
    }
}
